import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { AlterLocalizationProvider } from 'bernie-alter';
import { Layer, ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { SearchCriteriaModel } from 'src/common/stores/models/search-criteria-model';

import { ReviewsDialog } from 'components/infosite/property-details/reviews-dialog';

interface ReviewsDialogLayerModel {
  searchCriteria: SearchCriteriaModel;
  onReviewsDialogClosed: () => void;
}

export const ReviewsDialogLayer = ({ searchCriteria, onReviewsDialogClosed }: ReviewsDialogLayerModel) => (
  <>
    <Layer id="infosite-reviews" onDismiss={onReviewsDialogClosed}>
      <AlterLocalizationProvider>
        {searchCriteria && searchCriteria.travelerType && searchCriteria.travelerType.length > 0 && (
          <AbacusExperiment name="PWA_HIS_DATED_PDP_Reviews_Alignment_By_Traveler_Type_Filters">
            <AbacusControl />
            <AbacusVariant bucket={1} />
          </AbacusExperiment>
        )}
        <Viewport>
          <ViewSmall>
            <ReviewsDialog onDismiss={onReviewsDialogClosed} />
          </ViewSmall>
          <ViewMedium>
            <ReviewsDialog onDismiss={onReviewsDialogClosed} fullScreen={true} />
          </ViewMedium>
          <ViewLarge>
            <ReviewsDialog onDismiss={onReviewsDialogClosed} fullScreen={true} splitView={true} />
          </ViewLarge>
        </Viewport>
      </AlterLocalizationProvider>
    </Layer>
  </>
);
